import './utils/installAdminConsole';
import React from "react";
import ReactDOM from "react-dom/client"; // Updated import
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./msalConfig";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { Provider } from 'react-redux'; // Import Redux Provider
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate
import { store, persistor } from './redux/store'; // Import store and persistor
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';


// Create a root element with React 18's createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the application
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>  {/* Wrap with Redux Provider */}
        <PersistGate loading={null} persistor={persistor}> {/* Wrap with PersistGate */}
          <AuthProvider>
            <App />
          </AuthProvider>
        </PersistGate>
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);
